"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockCompanyExtras = void 0;
const faker_1 = require("@faker-js/faker");
const createMockCompanyExtras = (overwrites = {}) => {
    return Object.assign({ id: faker_1.faker.datatype.number(), industry: faker_1.faker.company.bsBuzz(), subIndustry: faker_1.faker.company.bsBuzz(), sicCodes: faker_1.faker.datatype.uuid(), yearFounded: faker_1.faker.date.past().getFullYear(), primaryNAICS: faker_1.faker.company.bsBuzz(), secondaryNAICS: faker_1.faker.company.bsBuzz() }, overwrites);
};
exports.createMockCompanyExtras = createMockCompanyExtras;
//# sourceMappingURL=CompanyExtras.factory.js.map